import React from 'react';
import { cn } from 'App/shadcn/lib/utils';
import T from 'Components/Helpers/translate';

type Props = {
	replies: string[];
	disabled?: boolean;
	onSelect: (text: string) => void;
};

const SuggestedReplies = ({ replies, disabled, onSelect }: Props) => {
	if (!replies.length) return null;
	return (
		<div
			className="flex flex-wrap gap-2 -mt-2"
			role="group"
			aria-label={T('assistant.suggestedReplies.ariaLabel')}
		>
			{replies.map((text, i) => (
				<button
					key={`${i}-${text}`}
					type="button"
					disabled={disabled}
					onClick={() => onSelect(text)}
					className={cn(
						'inline-flex items-center rounded-full border border-border bg-background',
						'px-3 py-1.5 text-body-sm text-grey-11',
						'hover:bg-grey-1 hover:text-foreground hover:border-grey-5',
						'transition-colors cursor-pointer',
						'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-background'
					)}
				>
					{text}
				</button>
			))}
		</div>
	);
};

export default SuggestedReplies;
